import { elementOpen, elementClose, elementVoid, text, skip as incdomSkip } from 'incremental-dom';
var capitalACharCode = 'A'.charCodeAt(0);
var capitalZCharCode = 'Z'.charCodeAt(0);
var isUpper = function (input, index) {
    var charCode = input.charCodeAt(index);
    return capitalACharCode <= charCode && capitalZCharCode >= charCode;
};
var toKebabCase = function (camelCased) {
    var kebabCased = '';
    for (var i = 0; i < camelCased.length; i++) {
        var prevUpperCased = i > 0 ? isUpper(camelCased, i - 1) : true;
        var currentUpperCased = isUpper(camelCased, i);
        var nextUpperCased = i < camelCased.length - 1 ? isUpper(camelCased, i + 1) : true;
        if (!prevUpperCased && currentUpperCased || currentUpperCased && !nextUpperCased) {
            kebabCased += '-';
            kebabCased += camelCased[i].toLowerCase();
        }
        else {
            kebabCased += camelCased[i];
        }
    }
    return kebabCased;
};
var escapeAttrNodeValue = function (value) {
    return value.replace(/(&)|(")|(\u00A0)/g, function (_, amp, quote) {
        if (amp)
            return '&amp;';
        if (quote)
            return '&quot;';
        return '&nbsp;';
    });
};
var attributeToString = function (attributes) { return function (name) {
    var value = attributes[name];
    var formattedName = toKebabCase(name);
    var makeAttribute = function (value) { return formattedName + "=\"" + value + "\""; };
    if (value instanceof Date) {
        return makeAttribute(value.toISOString());
    }
    else
        switch (typeof value) {
            case 'boolean':
                // https://www.w3.org/TR/2008/WD-html5-20080610/semantics.html#boolean
                if (value) {
                    return formattedName;
                }
                else {
                    return '';
                }
            default:
                return makeAttribute(escapeAttrNodeValue(value.toString()));
        }
}; };
// const attributesToString = (attributes: Attributes | undefined): string => {
//     if (attributes) {
//         return ' ' + Object.keys(attributes)
//             .map(attributeToString(attributes))
//             .filter(attribute => attribute.length) // filter out negative boolean attributes
//             .join(' ');
//     } else {
//         return '';
//     }
// };
// const contentsToString = (contents: any[] | undefined) => {
//     if (contents) {
//         return contents
//             .map(elements => Array.isArray(elements) ? elements.join('\r') : elements)
//             .join('\r');
//     } else {
//         return '';
//     }
// };
var isVoidElement = function (tagName) {
    return [
        'area',
        'base',
        'br',
        'col',
        'command',
        'embed',
        'hr',
        'img',
        'input',
        'keygen',
        'link',
        'meta',
        'param',
        'source',
        'track',
        'wbr'
    ].indexOf(tagName) > -1;
};
export function Fragment(attributes, children) {
    return function () {
        children.map(function (c) {
            if (typeof c === 'function') {
                c();
            }
            else {
                text(c);
            }
        });
    };
}
// TODO: Add element keys
export function createElement(name, attributes) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    if (typeof name === 'function') {
        return (name(attributes, children));
    }
    else {
        var tagName_1 = toKebabCase(name);
        var AkeyArray = attributes
            ? Object.keys(attributes).map(function (k) { return [k, attributes[k]]; })
            : [];
        var dangerouslySetInnerHTML_1 = null;
        var elementReferenceFunction_1 = null;
        var Akeys_1 = AkeyArray.reduce(function (a, c) {
            if (c[0] === 'dangerouslySetInnerHTML') {
                dangerouslySetInnerHTML_1 = c[1];
                return a;
            }
            if (c[0] === 'ref') {
                elementReferenceFunction_1 = c[1];
                return a;
            }
            return (a.concat(c));
        }, []);
        if (isVoidElement(tagName_1) && !children.length) {
            return function () {
                var el = elementVoid(tagName_1, "key-" + Math.floor(Math.random() * 4294967295).toString(16), Akeys_1);
                if (elementReferenceFunction_1) {
                    elementReferenceFunction_1(el);
                }
            };
        }
        else {
            if (tagName_1 === 'render') {
                // TODO: Depracation warning once per run
                children.map(function (c) {
                    if (typeof c === 'function') {
                        c();
                    }
                    else {
                        text(c);
                    }
                });
                return true;
            }
            else if (tagName_1 === 'fragment') {
                // TODO: Deprecation warning once per run
                return function () {
                    children.map(function (c) {
                        if (typeof c === 'function') {
                            c();
                        }
                        else {
                            text(c);
                        }
                    });
                };
            }
            else {
                // NICE: Keys could be generated at build time in a post loader to improve runtime performance
                return function () {
                    var el = elementOpen(tagName_1, "key-" + Math.floor(Math.random() * 4294967295).toString(16), Akeys_1);
                    if (dangerouslySetInnerHTML_1) {
                        el.innerHTML = dangerouslySetInnerHTML_1;
                        incdomSkip();
                    }
                    else {
                        children.map(function (c) {
                            if (typeof c === 'function') {
                                c();
                            }
                            else {
                                text(c);
                            }
                        });
                    }
                    elementClose(tagName_1);
                    if (elementReferenceFunction_1) {
                        elementReferenceFunction_1(el);
                    }
                };
            }
        }
    }
}
//# sourceMappingURL=incdom.js.map